import { FC } from 'react'
import { useUA } from 'context'
import styled, { css } from 'styled-components'

interface IFProps {
  label: string
}

const BenefitChip: FC<IFProps> = ({ label }) => {
  const { isMobile } = useUA()

  return <StyledWrapper isMobile={!!isMobile}>{label}</StyledWrapper>
}

export default BenefitChip

type TStyledWrapperProps = {
  isMobile: boolean
}

const StyledWrapper = styled.span<TStyledWrapperProps>`
  ${({ theme, isMobile }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: fit-content;
    height: 34px;
    border-radius: 17px;
    background-color: ${theme.color.primary_2};
    color: ${theme.background.bg_8};
    font-weight: bold;
    font-family: 'GmarketSansMedium';
    line-height: 34px;
    ${isMobile ? mobileStyles : desktopStyles}
  `}
`

const desktopStyles = css`
  min-width: 74px;
  height: 34px;
  padding: 0 15px;
  margin: 50px 0 16px;
  font-size: 16px;
`

const mobileStyles = css`
  min-width: 55px;
  height: 28px;
  padding: 8px 12px;
  margin: 0 auto 8px;
  font-size: 12px;
`
